import dispatchAxiosUpdatedEvent from './axios-updated-event';

function handleSuccess(response, tag = 'AXIOS') {
	const currentRequestNumber = response.config.number;
	const currentRequestNumberPadded = currentRequestNumber.toString().padStart(3, 0);
	const responseDataSize = roughSizeOfObject(response.data);
	const responseDataSizeHR = dataSizeHumanReadable(responseDataSize);
	const requestMethod = response.config?.method?.toUpperCase();

	const labelColor = '#41b883';
	const tagTextColor = tag === 'AXIOS' ? 'white' : 'red';

	let label = response.config.url;

	if (response?.data && response.data.mime) label += ' (' + response.data.mime + ')';

	window.debug.axios.requests[currentRequestNumber].success = true;
	window.debug.axios.requests[currentRequestNumber].size = responseDataSize;

	console.groupCollapsed(
		`%c[${tag}#${currentRequestNumberPadded}] ${requestMethod}%c${label.replace(
			/\?.*/,
			''
		)}%c  ~${responseDataSizeHR}`,
		`background:#35495e ; padding: 3px 6px 3px 4px; border-radius: 3px 0 0 3px;  color: ${tagTextColor}`,
		`background:${labelColor} ; padding: 3px 6px 3px 6px; border-radius: 0 3px 3px 0;  color: #fff`,
		'background:transparent;color:gray'
	);
	console.log(`[${tag}#${currentRequestNumberPadded}] Request done successfully: ${label}`);
	console.log('RESPONSE', response);
	console.log(responseDataSize.toLocaleString() + ' bytes');
	console.groupEnd();

	dispatchAxiosUpdatedEvent();
}

function dataSizeHumanReadable(size) {
	var i = -1;
	var byteUnits = ['kB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
	do {
		size = size / 1024;
		i++;
	} while (size > 1024);

	return Math.max(size, 0.1).toFixed(1) + ' ' + byteUnits[i];
}

function roughSizeOfObject(object) {
	var objectList = [];
	var stack = [object];
	var bytes = 0;

	while (stack.length) {
		var value = stack.pop();

		if (typeof value === 'boolean') {
			bytes += 4;
		} else if (typeof value === 'string') {
			bytes += value.length * 2;
		} else if (typeof value === 'number') {
			bytes += 8;
		} else if (typeof value === 'object' && objectList.indexOf(value) === -1) {
			objectList.push(value);

			for (var i in value) {
				stack.push(value[i]);
			}
		}
	}
	return bytes;
}

export default handleSuccess;
